// Déclaration du ResizeObserver
const observer = new ResizeObserver(() => {
  // Observer sans effet ici, on peut étendre la logique si nécessaire
});

let script_loaded = false;

function loadJSscripts() {
  if (!script_loaded) {
    script_loaded = true;

    // Lazy load des iframes
    document.querySelectorAll("iframe.lazy").forEach(iframe => {
      const datasrc = iframe.dataset.src;
      if (datasrc != null) iframe.src = datasrc;
    });

    // Lazy load des scripts
    const scripts = document.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
      const script = scripts[i];
      const dataSrc = script.getAttribute("data-src");

      if (dataSrc) {
        script.setAttribute("src", dataSrc);
        delete script.dataset.src;
      }

      if (script.type === "text/lazyload") {
        const newScript = document.createElement("script");
        for (let a = 0; a < script.attributes.length; a++) {
          const attr = script.attributes[a];
          newScript.setAttribute(attr.name, attr.value);
        }
        newScript.type = "text/javascript";
        newScript.innerHTML = script.innerHTML;

        const parent = script.parentNode;
        parent.removeChild(script);
        parent.insertBefore(newScript, script);
      }
    }

    // Lazy load des liens
    const links = document.getElementsByTagName("link");
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const dataHref = link.getAttribute("data-href");
      if (dataHref) {
        link.setAttribute("href", dataHref);
        delete link.dataset.href;
      }
    }

    // Notification de chargement complet
    document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  }
}

// Événements utilisateur pour déclencher le chargement
const activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];
activityEvents.forEach(event => {
  window.addEventListener(event, loadJSscripts, false);
});

// Fallbacks pour le chargement initial
if (window.addEventListener) {
  window.addEventListener("load", () => {}, false);
} else if (window.attachEvent) {
  window.attachEvent("onload", () => {});
} else {
  window.onload = () => {};
}
